var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartIconRegular = function SvgHeartIconRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M6.974 2.751a2.981 2.981 0 0 0-4.286 0 3.155 3.155 0 0 0 0 4.388l5.573 5.705c.408.418 1.07.418 1.478 0l5.573-5.705a3.155 3.155 0 0 0 0-4.388 2.981 2.981 0 0 0-4.286 0l-1.39 1.423a.885.885 0 0 1-1.272 0l-1.39-1.423Zm-5.56-1.303a4.752 4.752 0 0 1 6.833 0L9 2.22l.753-.772a4.752 4.752 0 0 1 6.832 0c1.887 1.932 1.887 5.063 0 6.994l-5.573 5.705a2.8 2.8 0 0 1-4.024 0L1.415 8.442c-1.887-1.931-1.887-5.062 0-6.994Z",
    clipRule: "evenodd"
  })));
};
export default SvgHeartIconRegular;